import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { FamilyContext } from '../Context/FamilyHeadContext';
import {useTranslation} from "react-i18next";
import hebrewStyles from '../data/hebrewFamilyHeadStyles.json';
import englishStyles from '../data/englishFamilyHeadStyles.json';

const FamilyTitles = () => {
    const { currentFamilyHead, pathPrefix } = useContext(FamilyContext);
    const {i18n} = useTranslation();

    // בחירת הסגנון לפי השפה
    const styles = i18n.language === 'en' ? englishStyles : hebrewStyles;
    const activeStyle = styles[currentFamilyHead.nickname];

    return (
        <div className="flex flex-col items-center justify-center gap-2 break-words max-w-full">
            <Link
                to={`${pathPrefix}person/${currentFamilyHead.gedId}`}
                className="cursor-pointer hover:text-[#698fb8] transition-colors duration-300 whitespace-normal">
                {activeStyle.title}
            </Link>
        </div>
    );
};

export default FamilyTitles;